'use client';

import { type SymbolMatch, searchAlphaSymbols } from '@/actions/assets/search-symbols';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export function useSymbolSearch() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<SymbolMatch[]>([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef<number | null>(null);

  const search = useCallback(async (q: string) => {
    setLoading(true);
    try {
      const data = await searchAlphaSymbols(q);
      setResults(data);
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (debounceRef.current) window.clearTimeout(debounceRef.current);
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      return;
    }
    debounceRef.current = window.setTimeout(() => search(q), 350);
  }, [query, search]);

  const setSearch = useCallback((v: string) => setQuery(v), []);

  return useMemo(
    () => ({ query, setQuery: setSearch, results, loading }),
    [query, setSearch, results, loading]
  );
}
